module.exports = __webpack_public_path__ + "img/haim_katz_neeman.6b0edcbe.jpg";